import { useState } from 'react'
import Modal from './index'

/**
 * Exemple d'utilisation du composant Modal avec composition
 */
const ModalCompositionExample = () => {
  // États des différentes modales
  const [isBasicModalOpen, setIsBasicModalOpen] = useState(false)
  const [isComposedModalOpen, setIsComposedModalOpen] = useState(false)
  
  // Utilisation du hook useModal
  const { isOpen, handleShow, handleHide, dialogRef } = Modal.useModal()

  return (
    <div className="p-6 space-y-6">
      <h2 className="text-2xl font-bold">Exemples de Modales avec Composition</h2>
      
      <div className="flex flex-wrap gap-4">
        <button className="btn btn-primary" onClick={() => setIsBasicModalOpen(true)}>
          Modal Basique
        </button>
        
        <button className="btn btn-secondary" onClick={() => setIsComposedModalOpen(true)}>
          Modal Composée
        </button>
        
        <button className="btn btn-accent" onClick={handleShow}>
          Modal avec Hook
        </button>
      </div>

      {/* Modal basique */}
      <Modal
        open={isBasicModalOpen}
        onClose={() => setIsBasicModalOpen(false)}
        backdrop={true}
      >
        <Modal.Header>Titre de la Modal</Modal.Header>
        <Modal.Body>
          <p>Ceci est une modal basique utilisant la composition.</p>
          <p className="mt-2">Vous pouvez facilement construire des modales avec cette API modulaire.</p>
        </Modal.Body>
        <Modal.Actions>
          <button className="btn" onClick={() => setIsBasicModalOpen(false)}>Fermer</button>
        </Modal.Actions>
      </Modal>

      {/* Modal composée avec plus d'options */}
      <Modal
        open={isComposedModalOpen}
        onClose={() => setIsComposedModalOpen(false)}
        position="bottom"
        responsive={true}
        className="max-w-2xl"
      >
        <Modal.Header showCloseButton={true}>Formulaire</Modal.Header>
        <Modal.Body className="space-y-4">
          <div className="form-control">
            <label className="label">
              <span className="label-text">Nom</span>
            </label>
            <input type="text" placeholder="Votre nom" className="input input-bordered" />
          </div>
          
          <div className="form-control">
            <label className="label">
              <span className="label-text">Email</span>
            </label>
            <input type="email" placeholder="Votre email" className="input input-bordered" />
          </div>
          
          <div className="form-control">
            <label className="label">
              <span className="label-text">Message</span>
            </label>
            <textarea className="textarea textarea-bordered" placeholder="Votre message"></textarea>
          </div>
        </Modal.Body>
        <Modal.Actions>
          <button className="btn" onClick={() => setIsComposedModalOpen(false)}>Annuler</button>
          <button className="btn btn-primary" onClick={() => setIsComposedModalOpen(false)}>Envoyer</button>
        </Modal.Actions>
      </Modal>

      {/* Modal avec useModal hook */}
      <Modal
        open={isOpen}
        onClose={handleHide}
        ref={dialogRef}
        backdrop={true}
        className="bg-success text-success-content"
      >
        <div className="text-center">
          <h3 className="font-bold text-lg mb-4">Succès avec useModal</h3>
          <p>Cette modal utilise le hook useModal pour sa gestion d'état.</p>
          <div className="mt-6">
            <button className="btn btn-outline" onClick={handleHide}>Fermer</button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ModalCompositionExample